import { createApp } from "vue";
import App from "./App.vue";
import "./assets/style/app.css";

createApp(App).mount("#app");
